import appSessionStore from '@/lib/redux/app-session-slice'
import cartStore from '@/lib/redux/cart-slice'
import checkoutStore from '@/lib/redux/checkout-slice'
import modalsStore from '@/lib/redux/modals-slice'
import selectedProductStore from '@/lib/redux/selected-product-slice'
import storage from '@/lib/storage'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
} from 'redux-persist'

const appSessionPersistConfig = {
  key: 'appSession',
  storage,
  blacklist: ['userPin'],
}

const rootReducer = combineReducers({
  modals: modalsStore,
  selectedProduct: selectedProductStore,
  cart: cartStore,
  checkout: checkoutStore,
  appSession: persistReducer(appSessionPersistConfig, appSessionStore),
})

const persistConfig = {
  key: 'cloudpos-root',
  version: 1,
  storage,
  blacklist: ['appSession'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const makeStore = () => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  })
  return store
}

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
